import React from 'react';
import useStyles from './styles';

const LoadingButton = ({
  size = 14,
  color = '#191a1a',
}) => {
  const classes = useStyles();
  const divStyle = {
    width:  size+'px',
    height: size+'px',
    marginTop: '-'+(size*.75)+'px',
  };

  return (
    <div className={classes.rtmWrapper} style={divStyle}>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g>
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm.5 3a3.5 3.5 0 0 1 1.82 6.49L16.868 17h-2.472l-2.18-3H10v3H8V7h4.5zm0 2H10v3h2.5a1.5 1.5 0 0 0 1.493-1.356L14 10.5A1.5 1.5 0 0 0 12.5 9z" fillRule="nonzero" fill={color}/>
        </g>
      </svg>
    </div>
  );
};

export default LoadingButton;
